import { styled } from "styled-components";

export const CreateForm = styled.form`
  margin-top: 20px;
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  text-align: left;
  flex-grow: 1;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const FormInput = styled.input`
  width: 98.3%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const InlineInput = styled.div`
  display: flex;
  gap: 10px;
`

export const FormTextarea = styled.textarea`
  width: 98.3%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const ErrorMessage = styled.div`
  background-color: rgb(206 43 43 / 54%);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 30px;
  color: #dc3545;
  font-size: 14px;
  margin-top: 5px;
`;

export const SuccessMessage = styled.div`
  background-color: rgb(43 206 55 / 54%);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 30px;
  color: #ffffff;
  font-size: 14px;
  margin-top: 5px;
  text-align: left;
`;

export const FormSearch = styled.input`
  width: 300px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 20px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
`;

export const RadioInput = styled.input`
  margin-right: 5px;
`;